export const SEO_TAGLINE = 'Verified Wisdom, Powerful Transformations';
export const SEO_LOGO_PATH = '/wisdom-network-logo.png';
export const SEO_SITE_NAME = 'The Wisdom Network';
const BRANDED_ORIGIN = 'https://www.thewisdomnetwork.net';

export const getSiteOrigin = () => {
  const hostname = window.location.hostname.toLowerCase();
  return hostname === 'thewisdomnetwork.net' || hostname.endsWith('.thewisdomnetwork.net')
    ? BRANDED_ORIGIN
    : window.location.origin;
};

export const withBrandTagline = (description) =>
  `${SEO_TAGLINE} — ${String(description || '').trim()}`;

export const upsertMeta = (selector, attributes, content) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

export const updateSocialMetadata = ({ title, description, url, type = 'website' }) => {
  const socialDescription = withBrandTagline(description);
  const logoUrl = `${getSiteOrigin()}${SEO_LOGO_PATH}`;

  [
    ['meta[property="og:title"]', { property: 'og:title' }, title],
    ['meta[property="og:description"]', { property: 'og:description' }, socialDescription],
    ['meta[property="og:url"]', { property: 'og:url' }, url],
    ['meta[property="og:type"]', { property: 'og:type' }, type],
    ['meta[property="og:site_name"]', { property: 'og:site_name' }, SEO_SITE_NAME],
    ['meta[property="og:image"]', { property: 'og:image' }, logoUrl],
    ['meta[property="og:image:alt"]', { property: 'og:image:alt' }, `${SEO_SITE_NAME} logo`],
    ['meta[name="twitter:card"]', { name: 'twitter:card' }, 'summary_large_image'],
    ['meta[name="twitter:title"]', { name: 'twitter:title' }, title],
    ['meta[name="twitter:description"]', { name: 'twitter:description' }, socialDescription],
    ['meta[name="twitter:image"]', { name: 'twitter:image' }, logoUrl],
    ['meta[name="twitter:image:alt"]', { name: 'twitter:image:alt' }, `${SEO_SITE_NAME} logo`],
  ].forEach(([selector, attributes, content]) => upsertMeta(selector, attributes, content));
};
